import React from 'react';
import Recaptcha from 'react-grecaptcha';
import Cookie from 'js-cookie';

import { globalConfig } from 'applicationConfig';

var skipValidation = process.env.NODE_ENV === 'development' && globalConfig.REACT_APP_RECAPTCHA_SKIP_VALIDATION;

const RecaptchaContainter = (props) => {
  const successCallback = function(response) {
    Cookie.set(globalConfig.RECAPTCHA_RESPONSE_COOKIE_NAME, response);
    return props.onSuccess();
  };

  if (skipValidation) {
    window.setTimeout(successCallback, 1500);
  }

  return (
    <div className="recaptcha-container">
      <Recaptcha
        sitekey={globalConfig.RECAPTCHA_SITE_KEY}
        callback={successCallback}
        expiredCallback={props.onExpired}
        // Other props can be passed into the component.
        //data-theme="dark"
      />
    </div>
  );
};

export default RecaptchaContainter;



// WEBPACK FOOTER //
// ./src/common/components/Recaptcha/RecaptchaContainter.jsx